import localforage from "localforage";

const lf = localforage.createInstance({
  name: "pothen-new",
  storeName: "catalog-store",
});

const CATALOG_KEY = "catalog";
const CHILD_KEY = "child";

export default function catalogIndexedDbPlugin(store) {
  Promise.all([lf.getItem(CATALOG_KEY), lf.getItem(CHILD_KEY)])
    .then(([savedCatalog, savedChild]) => {
      if (savedCatalog) store.commit("catalog/SET_CATALOG", savedCatalog);
      if (savedChild) store.commit("catalog/SET_CHILD", savedChild);
    })
    .catch((err) => console.error("IDB rehydrate error:", err));

  store.subscribe((mutation, state) => {
    const { type } = mutation;

    if (type === "catalog/SET_CATALOG") {
      lf.setItem(CATALOG_KEY, state.catalog.catalog).catch((err) =>
        console.error("IDB write catalog error:", err)
      );
    }

    if (type === "catalog/SET_CHILD") {
      lf.setItem(CHILD_KEY, state.catalog.child).catch((err) =>
        console.error("IDB write child error:", err)
      );
    }

    if (type === "catalog/RESET_STATE" || type === "SET_LOGOUT") {
      lf.removeItem(CATALOG_KEY).catch(() => {});
      lf.removeItem(CHILD_KEY).catch(() => {});
    }
  });
}
